
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"EnterpriseLoggedOutMyPageHeader"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"enterpriseProgramSlug"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"PageHeader"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"queryMyPageHeader"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"enterpriseProgramSlug"},"value":{"kind":"Variable","name":{"kind":"Name","value":"enterpriseProgramSlug"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnterpriseLoggedOutPageHeader_MyPageHeader"},"directives":[]}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnterpriseLoggedOutPageHeader_MyPageHeader"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PageHeader_MyPageHeader"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"currentPageProgram"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnterpriseLoggedOutPageHeader_EnterpriseProgram"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"naptimeCurrentPageOrganization"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"EnterpriseLoggedOutPageHeader_NaptimeManagedThirdPartyOrganization"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnterpriseLoggedOutPageHeader_EnterpriseProgram"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EnterpriseProgram_EnterpriseProgram"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"naptimeThirdPartyOrganization"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"squareLogo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rectangularLogo"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"launchedAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"squareLogo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rectangularLogo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"skillsetAvailabilityType"},"arguments":[],"directives":[]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EnterpriseLoggedOutPageHeader_NaptimeManagedThirdPartyOrganization"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ThirdPartyOrganizationsV1"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"squareLogo"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"rectangularLogo"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":950}};
    doc.loc.source = {"body":"query EnterpriseLoggedOutMyPageHeader($enterpriseProgramSlug: String) {\n  PageHeader {\n    queryMyPageHeader(enterpriseProgramSlug: $enterpriseProgramSlug) {\n      ...EnterpriseLoggedOutPageHeader_MyPageHeader\n    }\n  }\n}\n\nfragment EnterpriseLoggedOutPageHeader_MyPageHeader on PageHeader_MyPageHeader {\n  currentPageProgram {\n    ...EnterpriseLoggedOutPageHeader_EnterpriseProgram\n  }\n  naptimeCurrentPageOrganization {\n    ...EnterpriseLoggedOutPageHeader_NaptimeManagedThirdPartyOrganization\n  }\n}\n\nfragment EnterpriseLoggedOutPageHeader_EnterpriseProgram on EnterpriseProgram_EnterpriseProgram {\n  id\n  slug\n  name\n  naptimeThirdPartyOrganization {\n    id\n    slug\n    name\n    squareLogo\n    rectangularLogo\n  }\n  launchedAt\n  squareLogo\n  rectangularLogo\n  skillsetAvailabilityType\n}\n\nfragment EnterpriseLoggedOutPageHeader_NaptimeManagedThirdPartyOrganization on ThirdPartyOrganizationsV1 {\n  id\n  slug\n  name\n  squareLogo\n  rectangularLogo\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["EnterpriseLoggedOutMyPageHeader"] = oneQuery(doc, "EnterpriseLoggedOutMyPageHeader");
        
        module.exports["EnterpriseLoggedOutPageHeader_MyPageHeader"] = oneQuery(doc, "EnterpriseLoggedOutPageHeader_MyPageHeader");
        
        module.exports["EnterpriseLoggedOutPageHeader_EnterpriseProgram"] = oneQuery(doc, "EnterpriseLoggedOutPageHeader_EnterpriseProgram");
        
        module.exports["EnterpriseLoggedOutPageHeader_NaptimeManagedThirdPartyOrganization"] = oneQuery(doc, "EnterpriseLoggedOutPageHeader_NaptimeManagedThirdPartyOrganization");
        
